import { render } from "./AsArticleContainer.vue?vue&type=template&id=1af240bb&ts=true"
import script from "./AsArticleContainer.vue?vue&type=script&lang=ts"
export * from "./AsArticleContainer.vue?vue&type=script&lang=ts"

import "./AsArticleContainer.vue?vue&type=style&index=0&id=1af240bb&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__